import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { PdfFile } from '../../../core/interfaces/pdf-file';
import { PdfFileType } from '../../../core/enums/pdf-file-type.enum';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../core/services/authentication.service';

import { PdfFileViewerComponent } from '../pdf-file-viewer/pdf-file-viewer.component';
import { PdfkitFileViewerComponent } from '../pdfkit-file-viewer/pdfkit-file-viewer.component';

@Component({
    selector: 'app-pdf-basic-viewer',
    templateUrl: './pdf-basic-viewer.component.html',
    imports: [PdfFileViewerComponent, PdfkitFileViewerComponent]
})
export class PdfBasicViewerComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() pdfFile: PdfFile;
  @Input() pdfFileType: PdfFileType;
  @Input() height: string;
  @Input() editable = true;

  @Input() pdfFileViewerClass: string;
  @Input() pdfKitViewerClass: string;

  @Input() pdfKitViewerContainerClass = 'pspdfkit-container';

  @Output() urlChange = new EventEmitter<string>();

  usePdfKitViewer: boolean;

  ngOnInit() {
    this.usePdfKitViewer = environment.featureData?.usePdfKitViewer &&
      this.authService.isCaptureAdminUser;
  }

  onUrlChange(url: string) {
    this.urlChange.emit(url);
  }
}
